import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StoreService {

  constructor() { }
  has(key: string) {
    const data = sessionStorage.getItem(key);
    return (data ? true : false);
  }
  set(key: string, value: any) {

    if (typeof value === 'object') {
      sessionStorage.setItem(key, JSON.stringify(value));
    }else{
      sessionStorage.setItem(key, value);

    }

  }
  get(key: string) {
    const data = sessionStorage.getItem(key);
    if (data) {
      if (this.isJsonString(data)) {
        return JSON.parse(data);
      }
      return data;
    }
    return false;
  }

  remove(key: string) {
    sessionStorage.removeItem(key);
  }

  clearSessionStorage() {
    sessionStorage.clear()
  }

  isJsonString(str: string) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }


  

}
